import { Injectable } from '@angular/core';
import { CommonChartmoduleService } from '../../../Services/common-chartmodule.service';
import { Observable, map } from 'rxjs';
import { SnapshotService } from '../../../Services/snapshot.service';

@Injectable({
  providedIn: 'root'
})
export class StackchartServiceService {
  custom: any;

  constructor(private commonchartmodules:CommonChartmoduleService, private _configService: SnapshotService) { }

  enableWheelScroll(chart: any) {
    this.commonchartmodules.enableWheelScroll(chart);
  }
  customColors = ["#9BC5E5", "#D5BCE4", "#F9C099", "#FF97A8", "#A6E2D7", "#BDE6BD", "#BFE1FD", "#F4E4B3", "#CD978B", "#EAC4D5"];
  patternImages = ['assets/Images/chartimages/Chart library_pattern colour 1.png', 'assets/Images/chartimages/Chart library_pattern colour 2.png', 
  'assets/Images/chartimages/Chart library_pattern colour 3.png', 'assets/Images/chartimages/Chart library_pattern colour 4.png', 
  'assets/Images/chartimages/Chart library_pattern colour 5.png', 'assets/Images/chartimages/Chart library_pattern colour 6.png',
   'assets/Images/chartimages/Chart library_pattern colour 7.png', 'assets/Images/chartimages/Chart library_pattern colour 8.png', 
   'assets/Images/chartimages/Chart library_pattern colour 9.png', 'assets/Images/chartimages/Chart library_pattern colour 10.png', 
   'assets/Images/chartimages/Chart library_pattern colour 11.png', 'assets/Images/chartimages/Chart library_pattern colour 12.png', 
   'assets/Images/chartimages/Chart library_pattern colour 13.png', 'assets/Images/chartimages/Chart library_pattern colour 14.png', 
   'assets/Images/chartimages/Chart library_pattern colour 15.png', 'assets/Images/chartimages/Chart library_pattern colour 16.png',
    'assets/Images/chartimages/Chart library_pattern colour 17.png', 'assets/Images/chartimages/Chart library_pattern colour 18.png', 
    'assets/Images/chartimages/Chart library_pattern colour 19.png', 'assets/Images/chartimages/Chart library_pattern colour 20.png',
  'assets/Images/chartimages/Chart library_pattern colour 21.png', 'assets/Images/chartimages/Chart library_pattern colour 22.png',
   'assets/Images/chartimages/Chart library_pattern colour 23.png', 'assets/Images/chartimages/Chart library_pattern colour 24.png', 'assets/Images/chartimages/Chart library_pattern colour 25.png'];

  customColors1 = this.customColors.map((color, index) => {
    const darkerShade = this.getDarkerShade(color);
    return {
      darkerShade: darkerShade,
      linearGradient: { x1: 0.4, x2: 0.5, y1: 0, y2: 0 },
      stops: [
        [0, color],
        [1, darkerShade]
      ]
    };
  });
 darkThemeBackgroundColor = '#333';
  defaultThemeBackgroundColor = 'white';
  darkThemeTextColor = 'white';
  defaultThemeTextColor = 'black';
  PatterncustomColors = ['url(#highcharts-default-pattern-1)', 'url(#highcharts-default-pattern-2)', 'url(#highcharts-default-pattern-3)',
    'url(#highcharts-default-pattern-4)', 'url(#highcharts-default-pattern-5)', 'url(#highcharts-default-pattern-6)'];
  plotBandsColor = '#DCDCDC';//'#F0F0F0';
  darkThemebg = '#333';
  lightThemebg = 'white';
  plotBandsdark = '#4f4f4f';

  lightThemeTextColor = 'black';
  textfont = 'KantarBrown-Regular';
  upwardTriangle = '&#9650';
  downwardTriangle = '\u25BC';
  sampleSizeConstant = 9000;
  baseImgPath = "assets/Images/chartimages/"
lowSampleText = "LS";
  nullValueText = "NA";
  changeValueFontSize = "80%";
 
  maxLabelCharacters = 4;

  highSignificance = 'green';
  lowSignificance = 'red';
  updatedCategories = [
    { name: 'Brand 1', image: 'assets/Images/chartimages/axisImage_01.png' },
    { name: 'Brand 2', image: 'assets/Images/chartimages/axisImage_02.png' },
    { name: 'Brand 3', image: 'assets/Images/chartimages/axisImage_03.png' },
    { name: 'Brand 4', image: 'assets/Images/chartimages/axisImage_04.png' },
    { name: 'Brand 5', image: 'assets/Images/chartimages/axisImage_05.png' },
    { name: 'Brand 6', image: 'assets/Images/chartimages/axisImage_06.png' },
    { name: 'Brand 7', image: 'assets/Images/chartimages/axisImage_07.png' },
    { name: 'Brand 8', image: 'assets/Images/chartimages/axisImage_08.png' },
    { name: 'Brand 9', image: 'assets/Images/chartimages/axisImage_09.png' },
  ];
  xAxisLabelOrientation(xAxisLabelOrientation: any, properties: any) {
    let rotation = 0; // Default rotation value for horizontal orientation

    if (xAxisLabelOrientation === 'vertical') {
      rotation = -90; // Rotate labels to vertical orientation
    } else if (xAxisLabelOrientation === 'angled') {
      rotation = -45; // Rotate labels to an angled orientation
    }

    return rotation;
  }

  customizeLegend(showlegend: any,popup:any, legendPos: any, properties: any): Highcharts.LegendOptions {
    let alignLegend: Highcharts.VerticalAlignValue = 'bottom'; // Default value
    let alignx: Highcharts.AlignValue | undefined = 'center';
    let layout1: Highcharts.OptionsLayoutValue | undefined = 'horizontal';
    let itemWidth: number | undefined = undefined;
    let maxHeight: number | undefined = undefined;

    if (showlegend) {
      switch (legendPos) {
        case "bottom":
          alignLegend = 'bottom';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "right":
          alignLegend = 'middle';
          alignx = 'right';
          layout1 = 'vertical';
          break;
        case "left":
          alignLegend = 'middle';
          alignx = 'left';
          layout1 = 'vertical';
          break;
        default:
          showlegend = false
          break;
      }
    }

   
    if (layout1 === 'horizontal') {
      itemWidth = popup ? undefined : 144; // Auto in popup so 2 columns fit at any zoom, fixed in regular view
      maxHeight = popup ? 500 : 50; // Much taller max height in popup for multi-line legends wrapped text
    }

    return {
      enabled: showlegend,
      align: alignx,
      verticalAlign: alignLegend,
      layout: layout1,
      itemWidth: itemWidth,
      maxHeight: maxHeight,
      itemHiddenStyle: {
        color: "gray"
      },
      itemStyle: {
        color: properties.darkTheme ? "white" : "black",
        fontWeight: "normal",
        fontFamily: this.textfont,
        fontSize: popup ? '0.8em' : '0.6em',
        whiteSpace: popup ? 'normal' : 'nowrap',
        overflow: popup ? 'visible' : 'hidden',
        textOverflow: popup ? 'clip' : 'ellipsis'
      } as any,
      labelFormatter: function() {
        // Only apply ellipsis in normal view, not in popup/expanded view
        if (popup) {
          return (this as any).name || '';
        }
        const maxLength = 15;
        const label = (this as any).name || '';
        if (label.length > maxLength) {
          return label.substring(0, maxLength) + '...';
        }
        return label;
      }
    };
  }

  getDarkerShade(color: any) {
    const darkenFactor = 0.9; // Adjust this factor for a darker shade
    const rgb = color.substring(1); // Remove the '#' from the color
    const r = parseInt(rgb.substring(0, 2), 16);
    const g = parseInt(rgb.substring(2, 4), 16);
    const b = parseInt(rgb.substring(4, 6), 16);
    const darkerR = Math.round(r * darkenFactor);
    const darkerG = Math.round(g * darkenFactor);
    const darkerB = Math.round(b * darkenFactor);
    return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
  }


  list:any;
  VerticalStackedcustomizationList(): Observable<any[]> {
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Vertical Stacked")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom.push(this.commonchartmodules.customizationObject.StackPosition)
        custom.push(this.commonchartmodules.customizationObject.HundredPercentStackedChart);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist()]
        return custom;
      })
    );
  }
  HorizontalStackedcustomizationList(): Observable<any[]> {
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Horizontal Stacked")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom.push(this.commonchartmodules.customizationObject.StackPosition)
        custom.push(this.commonchartmodules.customizationObject.HundredPercentStackedChart);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist()]
        return custom;
      })
    );
  }






  customization() {
    let custom: any = [
      {
        customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',options: this._configService.clientSnapshotAllStudyNames
      },
      {
        customization:'Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: '', id: '',select:2,options: [
          { value: 'metric1', label: 'Metric 1' },{ value: 'metric2', label: 'Metric 2' },{ value: 'metric3', label: 'Metric 3' },{ value: 'metric4', label: 'Metric 4' },
        ]
      },
      {
        customization: 'Widget Name : ', func: 'applycustomization', inputType: 'text', className: '', id: ''
      },
      {
        customization:'X Axis Label Orientation : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: 'X Axis Label Orientation',options: [
          { value: 'automatic', label: 'Automatic' },
          { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
          { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
          { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
        ]
      },
    ];
    custom=[...custom,...this.commonchartmodules.commoncustomizationlist()];
  
    return custom;
  }

  applycustomization(event:any,item:any,properties:any){
    this.commonchartmodules.applycustomization(event,item,properties)
  }
  // properties: any;
  // commonFunc(customization: any, event: any, property: any) {
  //   this.properties = property;
  //   switch (customization) {
  //     case 'Gridlines':
  //       this.properties.gridlines = event.target.classList.toggle('checked') ? 1 : 0;
  //       break;
  //     case 'Shadow':
  //       this.properties.shadow = event.target.classList.toggle('checked');
  //       break;
  //     case '100% Stacked Chart':
  //       this.properties.stacking = event.target.classList.toggle('checked') ? 1 : 0;
  //       this.properties.showNegative = false;
  //       break;
  //     case 'Legend Position : ':
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       this.properties.legendPosition = value;
  //       break;
  //     case 'Legend : ':
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       this.properties.showLegend = value == 'enable' ? true : false;
  //       break;
  //     case 'Dark Theme':
  //       this.properties.darkTheme = event.target.classList.toggle('checked');
  //       break;
  //     case 'Data Label : ':
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       this.properties.showDataLabel = value == 'enable' ? true : false;
  //       break;
  //     case 'Data Label Format : ':
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       this.properties.datalabelFormat = value;
  //       break;
  //     case 'Data Label Property : ':
  //       this.properties.datalabelStyle = event.target.value;
  //       break;
  //     case 'Data Label Position# : ':
  //       this.properties.dataLabelPosition = event.target.value;
  //       break;
  //     case 'Data Label Position : ':
  //       this.properties.dataLabelPosition = event.target.value;
  //       break;
  //     case 'Chart Title Position : ':
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       this.properties.chartTitlePosition = value;
  //       break;
  //     case 'Axis Label Orientation : ':
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       this.properties.axisLabelOrientation = value;
  //       break;
  //     case 'Plotbands#':
  //       this.properties.plotBands = event.target.classList.toggle('checked');
  //       break;
  //     case 'Axis Image':
  //       this.properties.axisImage = event.target.classList.toggle('checked');
  //       break;
  //     case 'Gradient Bar Color':
  //       this.properties.gradientBarColor = event.target.classList.toggle('checked');
  //       break;
  //     case 'Gradient Series Colors':
  //       this.properties.seriesGradient = event.target.classList.toggle('checked');
  //       break;
  //     case 'Negative Values':
  //       this.properties.showNegative = event.target.classList.toggle('checked');
  //       this.properties.stacking = 0;
  //       break;
  //     case 'Data Label Color : ':
  //       this.properties.dataLabelColor = event.target.value;
  //       break;
  //     case 'Data Label Size# : ':
  //       this.properties.dataLabelSize = event.target.value;
  //       break;
  //     case 'Data Label Position* : ':
  //       this.properties.dataLabelPosition = event.target.value;
  //       break;
  //     case 'Data Label Overlap# : ':
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       this.properties.allowOverlap = value == 'enable' ? true : false;
  //       break;
  //     case 'ToolTip Style# : ':
  //       this.properties.toolTipStyle = event.target.value;
  //       break;
  //     case 'Number of series : ':
  //       this.properties.noOfSeries = event.target.value;
  //       break;
  //   }
  // }

}
